<template>
	<button
		class="btn btn--extra-small btn--clean-link"
		type="button"
		:aria-label="i18n.share"
		ref="shareLink"
		data-module="modal"
		data-config='{"modalID": "modal-share" }'
		v-on:click="openPopup"
	>
		<span class="btn__icon">
			<ShareIcon class="icon-inline icon-inline--expanded svg-icon-share" aria-hidden="true" />
		</span>
		<span class="btn__text">{{ i18n.shareConfiguration }}</span>
	</button>
</template>

<script>
import ShareIcon from "./icons/ShareIcon";
import {MrModal} from "@level-level/recyclops";

export default {
	components: {
		ShareIcon
	},
	computed: {
		i18n: function() { return this.$i18n; },
	},
	methods: {
		openPopup: function() {
			const button = this.$refs.shareLink;

			new MrModal( button, {} );

			button.addEventListener( 'openMrModal', () => {} );
			button.addEventListener( 'closeMrModal', () => {} );
		}
	}
};
</script>
